import PropTypes from "prop-types";
import { Box, Grid, Typography, Button } from "@mui/material";

import Link from "../../atoms/mui/Link";
import ContactSupportButton from "../../atoms/buttons/ContactSupportButton";

const SurveyError = ({
  message,
  href,
  btnText = "Contact Support"
}) => (
  <Box
    style={{ height: "100%" }}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography variant="h5" align="center">
          {message}
        </Typography>
      </Grid>
      <Grid item container justifyContent="center">
        <Grid item>
          {href ? (
            <Link href={href}>
              <Button variant="contained" color="primary">
                {btnText}
              </Button>
            </Link>
          ) : (
            <ContactSupportButton
              label={btnText}
              subject="Problem with my Aclymate survey"
              message={`${message}\n\nSurvey link: ${window.location.href}`}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

SurveyError.propTypes = {
  message: PropTypes.string,
  href: PropTypes.string,
  btnText: PropTypes.node,
};

export default SurveyError;
